export const ERROR = 'Error';
export const ERROR_LIGHT = 'ErrorLight';
